import { EarningsInsight } from '@toggle/toggle';

export const parseEarningsInsights = (insights: EarningsInsight[]) => {
  const hasEarningsInsights = insights.length > 0;
  let earningsInsight = undefined;

  if (hasEarningsInsights) {
    const previewInsight = insights.find(insight => insight.type === 'preview');
    const recapInsight = insights.find(insight => insight.type === 'recap');
    earningsInsight = recapInsight ?? previewInsight;
  }

  return earningsInsight;
};
